<template>
  <a-modal
    v-model="show"
    width="50%"
    title="新增/编辑类型"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="cancel">
    <a-spin :spinning="loading">
      <a-form-data ref="form" v-model="row" :setting="setting" :render-data="renderData" />
    </a-spin>
  </a-modal>
</template>
<script>
  import API from '@/api'
  export default {
    props: {
      row: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        show: true,
        loading: false,
        setting: {
          rules: {
            name: [{ required: true, message: '请输入名称', trigger: 'change' }],
            code: [{ required: true, message: '请输入Code', trigger: 'change' }],
            value: [{ required: true, message: '请输入值', trigger: 'change' }],
            sort: [{ required: true, message: '请输入排序', trigger: 'change' }],
            tips: [{ required: true, message: '请输入描述', trigger: 'change' }],
            unit: [{ required: true, message: '请选择单位', trigger: 'change' }],
            status: [{ required: true, message: '请选择状态', trigger: 'change' }],
          }
        },
        renderData: {
          name: {
            label: '名称',
            valid: true,
          },
          code: {
            label: 'Code',
            valid: true
          },
          value: {
            label: '值',
            valid: true
          },
          sort: {
            label: '排序',
            valid: true
          },
          tips: {
            label: '描述',
            valid: true
          },
          status: {
            label: '状态',
            valid: true,
            renderName: 'aRadioGroup',
            options: [
              { label: '启用', value: 1 },
              { label: '禁用', value: 2 }
            ]
          }
        }
      }
    },
    methods: {
      async ok() {
        try {
          this.loading = true
          await this.$refs.form.formRef().validate()
          await this.$request({
            url: this.row.id ? API.type.typeEdit : API.type.typeAdd,
            method: 'post',
            data: this.row
          })
          this.$message.success('操作成功')
          await this.cancel()
        } catch (e) {
          console.log('e', e)
        } finally {
          this.loading = false
        }
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }
</script>
